// extracted by mini-css-extract-plugin
export var checkContainer = "mapLegend-module--checkContainer--36636";
export var checkboxWrapper = "mapLegend-module--checkboxWrapper--55412";
export var checkmark = "mapLegend-module--checkmark--ef563";
export var mapKey = "mapLegend-module--mapKey--2837f";
export var mapKeySvg = "mapLegend-module--mapKeySvg--93898";
export var mapKeyValue = "mapLegend-module--mapKeyValue--1979a";
export var nativeCheckbox = "mapLegend-module--nativeCheckbox--db556";
export var subheader = "mapLegend-module--subheader--1c17d";